import { useLazyQuery } from '@apollo/client'

import { GetProductOutOfStockModalDocument } from '@/graphql/purchase-plus/generated/getProductOutOfStockModal.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductOutOfStockModalProps {
  productId: number
}

export const useGetProductOutOfStockModal = ({ productId }: UseGetProductOutOfStockModalProps) => {
  const [fetchProductOutOfStockModal, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetProductOutOfStockModalDocument,
    {
      variables: {
        id: productId,
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    }
  )

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchProductOutOfStockModal,
    error,
    product: data?.product,
    loadingStates,
    refetch,
  }
}
